<template>
    <v-app id="inspire">
        <!-- Loading div -->
        <div class="loading lds-css ng-scope" :class="{'hide' : !charging}">
            <div  class="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
        <!-- Modal de fin -->
        <v-dialog
        v-model="finalModal"
        max-width="290"
        v-if="processComplete && !hasMessage"
        class="final-modal"
        >
      
            <v-card>
                <div class="top-background"></div>
            <v-divider></v-divider>
                <div class="modal-content">
                    <h3>Votre santé au bout des doigts</h3>
                    <p>Sur goMediCAL prenez RDV pour vous ou pour un proche en quelques clics avec un spécialiste de la santé.</p>
                </div>
            <v-card-actions>
                <v-btn
                flat
                href ="https://goo.gl/NNw2AC"
                class="modal-submit-button"
                >
                    T<span class="lowercase">élécharger</span>
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal paiement par portefeuille-->
        <v-dialog
        v-model="finalModal"
        width="300"
        v-if="pocketPayment"
        class="final-modal"
        >
      
        <v-card>
            <div class="top-pocketPayment">
                <img src="" alt="">
                <h2>Payer par votre portefeuille</h2>
            </div>
          <v-divider></v-divider>
            <div class="modal-content">
                <pocket-fields v-model="pocket"/>
            </div>
          <v-card-actions>
            <v-btn
              flat
              class="modal-submit-button"
            >
                 V<span class="lowercase">alider</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-btn 
                @click="pay" 
                class="submit-button"
                :loading='isloading'
                :class="{disabled: processComplete}"
                >
                P<span class="lowercase">ayer</span>
                <!-- &nbsp;{{cout + fraisTransaction}} Fcfa  -->
            </v-btn>

        <!-- <v-form v-model="valid"> -->
            <!-- Default fields -->
            <!-- <form-field v-model='name' placeholder='Nom et prénoms' :icon='nameIcon'/> -->
            <!-- Conditional rendered fields -->
            <!-- <mobile-money-fields v-model="mobilemoney" v-show ="mode === 'mobilemoney'" ref="MM"/>
            <credit-card-fields v-model="creditcard" v-show ="mode === 'credit-card'" ref="CC"/> -->
            
            <!-- <v-btn 
                @click="pay" 
                class="submit-button"
                :loading='isloading'
                :class="{disabled: processComplete}"
                >
                P<span class="lowercase">ayer</span>&nbsp;{{cout + fraisTransaction}} Fcfa 
            </v-btn>
        </v-form> -->
    </v-app>    
</template>

<script>
import formField from './FormField'
// import mobileMoneyFields from './MobileMoneyFields'
// import creditCardFields from './CreditCardFields'
import pocketFields from './PocketFields'
import kkiapay from 'kkiapay'
import httpcli from 'axios'

export default {
    props: {
        cout: Number,
        mode: {
            type: String,
            default: 'credit-card'
        },
        numberConsultation: [String, Number],
        hasMessage: Boolean,
        processComplete: Boolean,
        fraisTransaction: Number,
        referent: String,
        referentPhone: String,
        paymentType: String
    },
    data: () => ({
        charging: true,
        valid: false,
        finalModal: true,
        code: '',
        isloading: false,
        pocketPayment: false,
        mobilemoney: {
            phone: ''
        },
        creditcard: {
            email: '',
            card: '',
            expDate: '',
            cvc: ''
        },
        pocket: {
            phone: '',
            password: ''
        },
        /* Stripe datas */
        stripe: '',
        stripeKey: stripeKey,
        stripeElements: '',
        classes: {
            base : '.custom-input',
            focus: 'focused',
            empty: 'empty',
            invalid: 'invalid',
        },
        style: {
            base: {
                color: 'rgba(0,0,0,.87)'
            }
        },
        card: '',
        expDate: '',
        cvc: '',
        /* name datas*/
        name: '',
        nameIcon: require('../assets/user.svg')
    }),
    components: {
        formField,
        // mobileMoneyFields,
        // creditCardFields,
        pocketFields
    },

    created () {
        this.code = this.$route.params.code
    },

    mounted () {
        this.charging = false
    },
    // mounted: function () {
    //     let stripeKey = this.stripeKey
    //     let stripe = Stripe(stripeKey)
    //     let elements = stripe.elements()

    //     let cardNumber = elements.create('cardNumber', {classes: this.classes, style: this.style})
    //     let cardExpiry = elements.create('cardExpiry', {classes: this.classes, style: this.style})
    //     let cardCvc = elements.create('cardCvc', {classes: this.classes, style: this.style})

    //     // if (window.matchMedia("(max-width: 767px)").matches) {
    //         cardNumber.mount('#card-number')
    //         cardExpiry.mount('.exp-date-cvc #card-expiry')
    //         cardCvc.mount('.exp-date-cvc #card-cvc')
    //     // } 
    //     /* else {
    //         cardNumber.mount('.right-block #card-number')
    //         cardExpiry.mount('.right-block .exp-date-cvc #card-expiry')
    //         cardCvc.mount('.right-block .exp-date-cvc #card-cvc')
    //     } */

    //     this.stripe = stripe
    //     this.stripeElements = elements
    //     this.card = cardNumber
    //     this.expDate = cardExpiry
    //     this.cvc = cardCvc
    //     this.charging = false
    // },

    methods: {
        // checkFormFilling() {
        //     let checkResult = ''
        //     let isvalid = ''
        //     if (this.mode ==='mobilemoney')
        //     {
        //         isvalid = this.$refs.MM.isvalid()
        //     }
        //     else if (this.mode ==='credit-card')
        //     {
        //         isvalid = this.$refs.CC.isvalid()
        //     }
        //     checkResult = (this.name === '' || !isvalid)? false : true
        //     return checkResult
        // },
        // payWithStripe () {
        //     // this.charging = true
        //     this.isloading = true
        //     let stripe = this.stripe
        //     let elements = this.stripeElements
        //     let cardNumber = this.card
        //     stripe.createToken(cardNumber).then(data => {
        //         var stripeHandler = httpcli.create({
        //         baseURL: 'https://stripe-handler.gomedical.io/',
        //         timeout: 8000,
        //         });

        //         stripeHandler
        //         .post('/charge', {
        //         "amount" : this.cout + this.fraisTransaction,
        //         "token" : data.token.id,
        //         "reason" : "From Medical web payment page",
        //         "payload" : data,
        //         "consultation" : this.numberConsultation,
        //         "live": isLive
        //         })
        //         .then(response => {
        //             console.log('Stripe response', response)
        //             const axiosInstance = httpcli.create({
        //                 baseURL: endpoint,
        //                 timeout: 8000,
        //                 headers: {
        //                     'Content-Type':'application/json',
        //                     'x-app-key': '2f9ca294-94b5-4382-a70d-c8770765d496'
        //                 }
        //             })
        //           return axiosInstance.post('/rdv/updateRdvPayment', {
        //                 code: this.code,
        //                 transactionId: response.data.id,
        //                 payment: {
        //                   visaData: {
        //                     token: response.data.source
        //                   },
        //                   paymentMode:"PAY_BY_REFERENT",
        //                   paymentType : "VISA",
        //                   referentName : this.referent,
        //                   referentPhone : this.referentPhone
        //                 }
        //           }).then(response => {
        //               this.charging = false
        //               this.isloading = false
        //               this.$emit('show-msg','success')
                      
        //               /* clean the fields after transaction success */
        //               this.name = null
        //               this.email = null
        //               this.card = null
        //               this.expDate = null
        //               this.cvc = null
        //           })
        //         })
        //         .catch(error => {
        //         this.charging = false
        //         this.isloading = false
        //         console.log('error throwed by stripe', error)
        //         if (error.response) {
        //             const errorCode = error.response.data.reason.code
        //             const errorReason = error.response.data.reason.raw.decline_code
        //             console.log('errorCode', errorCode)
        //             console.log('errorReason', errorReason)
        //             console.log('error',error)
        //             switch(errorReason) {
        //             case 'insufficient_funds':
        //                 this.$emit('show-msg','transaction-error')
        //             default:
        //                 this.$emit('show-msg','processing-error')
        //             }
        //         }
        //         })
        //     }).catch(error => console.log('token generation error', error))
        // },
        // payWithMoMo () {
        //     const infosgetter = httpcli.create({
        //         baseURL: endpoint,
        //         timeout: 2000,
        //         headers: {
        //             'Content-Type':'application/json',
        //             'x-app-key': '2f9ca294-94b5-4382-a70d-c8770765d496'
        //         }
        //     });
        //     this.isloading = true
        //     const phoneNumber = this.mobilemoney.phone
            
        //     /* kkiapay integration */
        //     const k = kkiapay('CeTNyxAKORm5UBVy2gerlTuan3dEc2')

        //     // k.debit('229' + phoneNumber,this.cout + this.fraisTransaction)
        //     k.debit('229' + phoneNumber,this.cout)
        //     .then((res) => {
        //         console.log('res from k.debit',res)
        //         this.charging = false
        //         this.isloading = false
        //         let code = this.code

        //         infosgetter.post(`${endpoint}/rdv/updateRdvPayment`,{
        //           code: code,
        //           transactionId: res.transactionId,
        //           payment: {
        //             momoData: {
        //               amount: this.cout,
        //               mobileNetwork: 'MTN_MOBILE_MONEY',
        //               numberPhone: phoneNumber
        //             },
        //             paymentMode: "PAY_BY_REFERENT",
        //             paymentType: "MOMO",
        //             referentName: this.referent,
        //             referentPhone: this.referentPhone
        //           }
        //         })
        //         .then((rdv) => {
        //             this.$emit('show-msg','success')
        //             this.isloading = false
        //             this.name = null
        //             this.mobilemoney.phone = null
        //         }  
        //         )
        //     })
        //     .catch((err) => {
        //         this.charging = false
        //         this.isloading = false
        //         console.log('error throwed by k.debit', err)

        //             if (err.failureCode === 'insufficent_fund') {
        //                 this.$emit('show-msg', 'transaction-error')
        //             } else if(err.failureCode === 'processing_error') {
        //                 this.$emit('show-msg', 'processing-error')
        //             }
                
        //     })

        // },

        pay() {
            // this.charging = false
            // this.isloading = true
            const infosgetter = httpcli.create({
                baseURL: endpoint,
                timeout: 5000,
                headers: {
                    'Content-Type':'application/json',
                    'x-app-key': '2f9ca294-94b5-4382-a70d-c8770765d496'
                }
            })


            infosgetter.get(`/rdv/code/${this.code}`)
            .then(response => {
                const d = response.data.data.data

                console.log('Data == ', d)

                const prodKey = 'CeTNyxAKORm5UBVy2gerlTuan3dEc2'
                const sandBoxKey = 'f9364460cb5611e9b9927f0eca3a32d2'

                const data = JSON.stringify({
                    category: 'RDV',
                    paymentObject: {
                        rdvId: d.consultation,
                        payment: {
                            paymentMode: 'PAY_BY_REFERENT',
                            paymentType: this.paymentType === 'credit-card' ? 'VISA' : 'MOMO',
                            referentName: d.referent,
                            referentPhone: d.referentPhone
                        }
                    }
                })

                const kkiapayData = {
                    amount: this.cout,
                    position: "center",
                    data,
                    theme: "green"
                }

                if (isLive) {
                    kkiapayData.key = prodKey
                    kkiapayData.callback = "https://pay.gomedical.io"
                } else {
                    kkiapayData.key = sandBoxKey
                    kkiapayData.callback = "https://pay-dev.gomedical.io"
                    kkiapayData.sandbox = true
                }

                const kkRes = openKkiapayWidget(kkiapayData)

                // if (kkRes === undefined) {
                //     redirect
                // }
            })
            .catch(error => {
                console.error('error from FormField', error)
            })

            // let isvalid = this.checkFormFilling()
            // let paymentMode = this.mode
            // let data = {
            //     name : this.name
            // }
            // if(!isvalid){
            //     this.$emit('show-msg','error')
            // }
            // else {
            //     switch (paymentMode) {
            //         case 'mobilemoney':
            //             data.phone = this.mobilemoney.phone
            //             this.payWithMoMo()
            //             break;
            //         case 'credit-card':
            //             data.email = this.creditcard.email
            //             data.card = this.creditcard.card
            //             data.expdate = this.creditcard.expDate
            //             data.cvc = this.creditcard.cvc
            //             this.payWithStripe()
            //             break;
            //         default:
            //             break;
            //     }
            // }
        }
    }
}
</script>

<style>
/* Global styles */
.v-text-field .v-label {
  font-size: 0.75rem !important;
}
#inspire {
    font-size: 0.75rem !important;
}


/* Submit button styles */
.submit-button {
    background: #FFD44F !important;
    color: #fff !important;
    width: 100%;
    box-sizing: border-box;
    margin-left: -1px!important;
    margin-top: 1.5rem!important;
    font-size: 20px !important;
    font-weight: 900 !important;
}
.lowercase {
    text-transform: lowercase !important;
}
/* Vuetify  customized styles */
.application--wrap {
    min-height: 100% !important;
    background: #EFF6F9;
    margin-bottom: 20px;
}
.v-form {
    background: #fff;
}
/* Styles applied to loading div */
.hide {
  display: none;
}
@keyframes lds-ripple {
  0% {
    top: 96px;
    left: 96px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 18px;
    left: 18px;
    width: 156px;
    height: 156px;
    opacity: 0;
  }
}
@-webkit-keyframes lds-ripple {
  0% {
    top: 96px;
    left: 96px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 18px;
    left: 18px;
    width: 156px;
    height: 156px;
    opacity: 0;
  }
}
.lds-ripple {
  margin: auto;
  position: relative;
}
.lds-ripple div {
  box-sizing: content-box;
  position: absolute;
  border-width: 4px;
  border-style: solid;
  opacity: 1;
  border-radius: 50%;
  -webkit-animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(1) {
  border-color: #09e09d;
}
.lds-ripple div:nth-child(2) {
  border-color: #efe114;
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.lds-ripple {
  left: -50%;
  width: 200px !important;
  height: 200px !important;
  -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}


.loading {
  position: fixed;
  left: 50%;
  z-index: 999;
  height: 0em;
  overflow: show;
  margin: auto;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:gray;
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  opacity: 0.5;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;

  }
  /* Final modal styles */
  .top-background {
      height: 178px;
      background-image: url('../assets/modal_background.svg');
  }
  .modal-content {
      box-sizing: border-box;
      padding: 24px 24px 0;
  }
  .modal-submit-button {
    background: #2BA359 !important;
    color: #fff !important;
    width: 50%;
    box-sizing: border-box;
    font-weight: bold;
    display: flex !important;
    justify-content: center !important;
}
.v-card__actions .v-btn, .v-card__actions>* {
    margin: auto !important;
}

@media screen and (min-width:639px) {
    .v-dialog {
        max-width: 33.33% !important;
        max-height: 60% !important;
    }
    .v-dialog .top-background {
       /*  background-position: 33vw !important;
        background-repeat: no-repeat; */
        background-size: 100% !important;
    }
}
</style>
